export default {
  GET_BRANCHES: ({ page = 1, rowsPerPage = 100 }) => `attributes/locations/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_BRANCHES: 'attributes/branches',
  CREATE_BRANCH: 'attributes/locations/',
  UPDATE_BRANCH: (id) => `attributes/locations/${id}/`,
  DELETE_CATEGORY: (id) => `customers/${id}/delete/`,
};
